module.exports = __webpack_public_path__ + "static/media/observe.57b784a0.svg";